/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-template-curly-in-string */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable react/style-prop-object */
import React from "react";
import styles from "./Education.module.css";
import myPhoto from "./1.jpg";
import routeCertifi from './Route certificate.JPG'
import fwdCertifi from './FWD.JPG'

export default function Education() {
  return (
    <>
      <div className="row m-auto py-5 my-5 g-4 justify-content-center">
        {/*---------------------Img & welcome card-----------------*/}
        <div className="col-md-8">
          <div className="row  m-auto text-center align-items-center">
          <div className="col-md-6 mb-2">
            <img
              className="border border-4 rounded-5 border-success"
              src={myPhoto}
              alt=""
            />
          </div>
          {/*------------------------Card Body-----------------------*/}
          <div className="card-body col-md-6">
            <div className="row justify-content-center">
            <p className="card-text">
              Welcome to the educational part dedicated to me, where you can
              view all the studies I have obtained and certificates, and you can
              also download my CV. I hope you are happy to be here on my website
            </p>
            {/*------------------CV & Certificates buttons-------------*/}
            <div className="Buttons row g-2 justify-content-center">
<a href="https://drive.google.com/file/d/15cNs55esVpJhIrlDXvuFtF8iqp4p_Z9S/view?usp=sharing"
                className="btn btn-success border col-md-10 d-flex  justify-content-center"
                target="_blank"
              >
                Download CV
              </a>
            </div>
            {/*----------------------Last Update line------------------*/}
            <p className="card-text mt-3 mb-5">
              <small className="text-white-50">
                Last updated on 16 of Sep. 2022
              </small>
            </p>
            </div>
          </div>
          </div>
        </div>

        {/*-------------------My Education Cards-------------------*/}
        <div className="col-md-8 row g-4 m-auto">
        {/*-------------------Card 1-------------------*/}
<div className="card text-center  bg-transparent border border-4 border-success rounded-3" >
  <div className="card-body">
    <h5 className="card-title fw-bold">Engineering Certificate</h5>
    <p className="card-text">“Bachelor's in Chemical Engineering from Egyptian Academy for Engineering & Advanced Technology”</p>
    {/* <Link to='certificates' className={`btn btn-transparent border border-2 border-white rounded-2 text-white ${styles.btnHover}`}>Go Certificates</Link> */}
  </div>
</div>
        {/*-------------------Card 2-------------------*/}
<div className="card text-center bg-transparent border border-4 border-success rounded-3" >
    <div className="row">
<div className="col-md-4 align-items-center d-flex">
    <img src={routeCertifi} alt=""  className="w-100"/>
  </div>

  <div className="card-body col-md-8">
    <h5 className="card-title fw-bold">Route Academy Certificate</h5>
    <p className="card-text">“FrontEnd Web Developer Certificate from Route Academy where I studied (HTML / CSS / Bootstrap / JS / jQuery / JS / React.js / Redux)”</p>
    <a target={"_blank"} href="https://drive.google.com/file/d/1xKtj2zkmWA1VWkEB_9bBFD0W2QG6Epty/view?usp=sharing" className={`btn btn-transparent border border-2 border-white rounded-2 text-white ${styles.btnHover}`}>View the Certificate</a>
  </div>
  </div>
</div>
        {/*-------------------Card 3-------------------*/}
<div className="card text-center  bg-transparent border border-4 border-success rounded-3" >
  <div className="row">
  <div className="col-md-4 align-items-center d-flex">
    <img src={fwdCertifi} alt=""  className="w-100"/>
  </div>

  <div className="card-body col-md-8">
    <h5 className="card-title fw-bold">FWD Challenger Track</h5>
    <p className="card-text">“Challenger Track in HTML & CSS from FWD is a grant from the Ministry of Communications and it's cooperation with Udacity”</p>
    <a target={"_blank"} href="https://drive.google.com/file/d/15GO-bqlHSooKdZtZi6mYnJJx-tKvIG16/view?usp=sharing" className={`btn btn-transparent border border-2 border-white rounded-2 text-white ${styles.btnHover}`}>View the Certificate</a>
  </div>
  </div>
</div>



        </div>
      </div>
    </>
  );
}
